import { jsonServerRestClient, fetchUtils } from "admin-on-rest";
export const API_DEBUG = "https://api.staging.ola.id/admin";
// export const API_DEBUG = "https://api.ola.id/admin";
// export const API_DEBUG = "http://localhost:4000/admin";
export const API_SERVER = process.env.REACT_APP_SERVER || API_DEBUG;
const API_URL = API_SERVER.replace("/admin", "");
const API_SERVER_PRODUCTLIST = API_SERVER.replace("/admin", "");
export const API_REPORT = API_SERVER.replace("/admin", "");

// console.log(API_SERVER);

export const CLIENT_URL =
  API_URL === "https://ola.id" ? API_URL : "https://staging.ola.id";

export const TOKEN = "token";
export const PROFILE = "profile";
export const ROLE = "role";

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem(TOKEN);
  options.headers.set("Authorization", `Bearer ${token}`);
  return fetchUtils.fetchJson(url, options);
};

const restClient = jsonServerRestClient(API_SERVER, httpClient);
export const RestClient = function (type, resource, params) {
  if (type === "CREATE" && resource === "reloads") {
    let formData = new FormData();
    formData.append(
      "file",
      params.data.file[0].rawFile,
      params.data.file[0].title
    );
    // console.log(params.data);

    return new Promise((resolve) =>
      setTimeout(
        () =>
          resolve(
            UploadClient(formData, "/" + resource)
              .then((response) => response.json())
              .then(function (data) {
                return { data: { ...params.data, id: data.id } };
              })
          ),
        500
      )
    );
  } else if (type === "CREATE" && resource === "corporate_campaign") {
    let formData = new FormData();
    const obj = params.data;
    Object.keys(obj).map(function (key) {
      if (key === "file") {
        formData.append(
          "file",
          params.data.file[0].rawFile,
          params.data.file[0].title
        );
      } else {
        formData.append(key, obj[key]);
      }
      return [Number(key), obj[key]];
    });

    return new Promise((resolve) =>
      setTimeout(
        () =>
          resolve(
            UploadClient(formData, "/corporateCampaigns")
              .then((response) => response.json())
              .then(function (data) {
                return { data: { ...params.data, id: data.id } };
              })
          ),
        500
      )
    );
  } else if (type === "UPDATE" && resource === "corporate_campaign") {
    let formData = new FormData();
    const obj = params.data;
    Object.keys(obj).map(function (key) {
      if (key === "file") {
        formData.append(
          "file",
          params.data.file[0].rawFile,
          params.data.file[0].title
        );
      } else {
        // console.log(key, obj[key]);
        formData.append(key, obj[key]);
      }
      // console.log(key, obj[key]);
      return [Number(key), obj[key]];
    });
    return new Promise((resolve) =>
      setTimeout(
        () =>
          resolve(
            UploadClient(
              formData,
              `/corporateCampaigns/${params.data.id}`,
              "PUT"
            )
              .then((response) => response.json())
              .then(function (data) {
                return { data: { ...params.data, id: data.id } };
              })
          ),
        500
      )
    );
  } else if (type === "GET_MANY_REFERENCE" && resource === "failedUpload") {
    return new Promise((resolve) =>
      setTimeout(
        () =>
          resolve(
            RestApi("/reloads/" + encodeURIComponent(params.id))
              .then((response) => response.json())
              .then(function (data) {
                return { data: data.failed_upload || [] };
              })
          ),
        500
      )
    );
  } else if (type === "GET_LIST" && resource === "ticket") {
    return new Promise((resolve) =>
      setTimeout(
        () =>
          resolve(
            RestApiTicketList(`${API_URL}/ticket/products`)
              .then((response) => response.json())
              .then(function (data) {
                return { data: data || [], total: data.length || 0 };
              })
          ),
        500
      )
    );
  }

  if (resource === "corporate_campaign") {
    return new Promise((resolve) =>
      setTimeout(
        () => resolve(restClient(type, "corporateCampaigns", params)),
        500
      )
    );
  }
  if (resource === "sim") {
    return new Promise((resolve) =>
      setTimeout(() => resolve(restClient(type, "simCardBatchs", params)), 500)
    );
  }
  if (resource === "payment") {
    return new Promise((resolve) =>
      setTimeout(() => resolve(restClient(type, "paymentMethods", params)), 500)
    );
  }
  if (resource === "paymentmode") {
    return new Promise((resolve) =>
      setTimeout(() => resolve(restClient(type, "paymentModes", params)), 500)
    );
  }
  if (resource === "agency") {
    return new Promise((resolve) =>
      setTimeout(() => resolve(restClient(type, "agencies", params)), 500)
    );
  }

  if (resource === "campaignMarketers") {
    return new Promise((resolve) =>
      setTimeout(
        () => resolve(restClient(type, "campaignMarketers", params)),
        500
      )
    );
  }

  return new Promise((resolve) =>
    setTimeout(() => resolve(restClient(type, resource, params)), 500)
  );
};

export const UploadClient = (formData, path, method = "POST") => {
  var myHeaders = new Headers();
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  return fetch(API_SERVER + path, {
    method: method,
    body: formData,
    headers: myHeaders,
  });
};

export const RestJsonSKUFilter = (params) => {
  let myHeaders = new Headers();
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_SERVER + "/products/sku?filter=" + params;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestJsonReports = (params) => {
  let options = {};
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem(TOKEN);
  options.headers.set("Authorization", `Bearer ${token}`);
  options.method = "GET";
  const url = API_SERVER + "/reports/sales?" + params;
  //"/reports/orders";
  return fetch(url, options);
};

//just for test
export const RestMarketer = () => {
  let myHeaders = new Headers();
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_SERVER + "/products/sku";
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};
//API_SERVER+

export const RestApi = (urlParams) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_SERVER + urlParams;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};
export const RestApiClient = (urlParams) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_URL + urlParams;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};
export const RestApiTicketList = (urlParams) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = urlParams;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};
export const RestApiShortUrl = (urlParams) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_SERVER + "/shorturls/exists?slug=" + urlParams;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const loginClient = (params) => {
  const url = API_SERVER + "/sessions";
  return fetch(url, {
    method: "POST",
    body: params,
    headers: new Headers({ "Content-Type": "application/json" }),
  });
};

export const RestApiProductList = (urlParams) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_SERVER_PRODUCTLIST + urlParams;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiReSendEmail = (id) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_SERVER + "/orders/resend/" + id;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiTicket = (id) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_URL + "/ticket/products/" + id;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiTicketScan = (params) => {
  const body = JSON.stringify(params);
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_URL + "/ticket/scan";
  return fetch(url, {
    method: "POST",
    body: body,
    headers: myHeaders,
  });
};

export const RestApiUpdateSimCards = (params) => {
  const body = JSON.stringify(params);
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/simCards/${params.id}`;
  return fetch(url, {
    method: "PUT",
    body: body,
    headers: myHeaders,
  });
};

export const RestApiDownloadActiations = (params) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/activations/download?${params}`;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiCollections = () => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = API_URL + "/dashboard/collections";
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiKOL = (paramsId) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/campaignMarketers/${paramsId}`;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiKOLActions = (paramsId, params, method) => {
  const body = JSON.stringify(params);
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/campaignMarketers/${paramsId}`;

  let options = {
    method: method,
    body: body,
    headers: myHeaders,
  };

  return fetch(url, options);
};

export const RestApiDownloadKOL = (paramsId) => {
  let options = {};
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem(TOKEN);
  options.headers.set("Authorization", `Bearer ${token}`);
  options.method = "GET";
  const url = `${API_SERVER}/agencyMarketers/${paramsId}/download`;
  //"/reports/orders";
  return fetch(url, options);
};

export const RestApiCollectionMarketers = (paramsId) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_URL}/marketers/collections/${paramsId}`;
  // console.log(url);
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiChartCampaigns = (paramsId, startDate, endDate, type) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/campaignStats/${paramsId}/${type}?startDate=${startDate}&endDate=${endDate}`;
  // console.log(url);
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiAgencyCommissions = (paramsId) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/agencies/${paramsId}/commissions`;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiRequestCommission = (marketerId, params) => {
  const body = JSON.stringify(params);
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/marketers/${marketerId}/transactions`;

  let options = {
    method: "POST",
    body: body,
    headers: myHeaders,
  };

  return fetch(url, options);
};

export const RESTApiCorporate = (paramsId) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/corporateCampaigns/${paramsId}/email`;
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiChartContent = (paramsId, startDate, endDate) => {
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/contents/${paramsId}/chart?startDate=${startDate}&endDate=${endDate}`;
  // console.log(url);
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};

export const RestApiChartState = (paramsId, startDate, endDate) => {
  ///admin/contents/:contentid/saleChart?startDate=&endDate=
  let myHeaders = new Headers({ "Content-Type": "application/json" });
  const token = localStorage.getItem(TOKEN);
  myHeaders.append("Authorization", `Bearer ${token}`);
  const url = `${API_SERVER}/contents/${paramsId}/saleChart?startDate=${startDate}&endDate=${endDate}`;
  // console.log(url);
  return fetch(url, {
    method: "GET",
    headers: myHeaders,
  });
};



// WEBPACK FOOTER //
// ./src/restClient.js